import englishMessages from 'ra-language-english'
import { TranslationMessages } from 'react-admin'

const customSpanishMessages: TranslationMessages = {
  ...englishMessages,
  ra: {
    ...englishMessages.ra,
    action: {
      ...englishMessages.ra?.action,
      add_filter: 'Añadir filtro',
      add: 'Añadir',
      back: 'Volver',
      bulk_actions: '%{smart_count} seleccionado(s)',
      cancel: 'Cancelar',
      clear_array_input: 'Limpiar lista',
      clear_input_value: 'Limpiar valor',
      clear: 'Limpiar',
      clone: 'Clonar',
      close_menu: 'Cerrar menú',
      close: 'Cerrar',
      confirm: 'Confirmar',
      create: 'Crear',
      create_item: 'Crear %{item}',
      delete: 'Eliminar',
      edit: 'Editar',
      expand: 'Expandir',
      export: 'Exportar',
      list: 'Listar',
      move_down: 'Mover abajo',
      move_up: 'Mover arriba',
      open_menu: 'Abrir menú',
      refresh: 'Actualizar',
      remove_all_filters: 'Quitar todos los filtros',
      remove_filter: 'Quitar filtro',
      remove: 'Eliminar',
      reset: 'Restablecer',
      save: 'Guardar',
      search: 'Buscar',
      select_all: 'Seleccionar todo',
      select_columns: 'Columnas',
      select_row: 'Seleccionar fila',
      show: 'Mostrar',
      sort: 'Ordenar',
      toggle_theme: 'Cambiar tema',
      undo: 'Deshacer',
      unselect: 'Deseleccionar',
      update: 'Actualizar',
      update_application: 'Recargar aplicación',
    },
    boolean: {
      true: 'Sí',
      false: 'No',
      null: ' ',
    },
    page: {
      ...englishMessages.ra?.page,
      create: 'Crear %{name}',
      dashboard: 'Inicio',
      edit: '%{name} %{recordRepresentation}',
      empty: 'Sin %{name} todavía.',
      error: 'Algo salió mal',
      invite: '¿Desea añadir uno?',
      list: '%{name}',
      loading: 'Cargando',
      not_found: 'No encontrado',
      show: '%{name} %{recordRepresentation}',
    },
    input: {
      ...englishMessages.ra?.input,
      file: {
        upload_several: 'Arrastre archivos aquí o haga clic para seleccionar.',
        upload_single: 'Arrastre un archivo aquí o haga clic para seleccionar.',
      },
      image: {
        upload_several: 'Arrastre imágenes aquí o haga clic para seleccionar.',
        upload_single: 'Arrastre una imagen aquí o haga clic para seleccionar.',
      },
      references: {
        all_missing: 'No se encontraron datos de referencia.',
        many_missing: 'Al menos una referencia no parece estar disponible.',
        single_missing: 'La referencia no parece estar disponible.',
      },
      password: {
        toggle_visible: 'Ocultar contraseña',
        toggle_hidden: 'Mostrar contraseña',
      },
    },
    message: {
      ...englishMessages.ra?.message,
      about: 'Acerca de',
      are_you_sure: '¿Está seguro?',
      auth_error: 'Error de autenticación',
      bulk_delete_content:
        '¿Está seguro de eliminar %{name}? |||| ¿Está seguro de eliminar estos %{smart_count} elementos?',
      bulk_delete_title: 'Eliminar %{name} |||| Eliminar %{smart_count} %{name}',
      bulk_update_content:
        '¿Está seguro de actualizar %{name}? |||| ¿Está seguro de actualizar estos %{smart_count} elementos?',
      bulk_update_title: 'Actualizar %{name} |||| Actualizar %{smart_count} %{name}',
      clear_array_input: '¿Está seguro de limpiar la lista completa?',
      delete_content: '¿Está seguro de eliminar este elemento?',
      delete_title: 'Eliminar %{name} #%{id}',
      details: 'Detalles',
      error: 'Ocurrió un error del cliente y no se pudo completar la solicitud.',
      invalid_form: 'El formulario no es válido. Por favor, revise los errores.',
      loading: 'La página se está cargando, espere un momento.',
      no: 'No',
      not_found: 'La URL ingresada es incorrecta o el enlace está roto.',
      yes: 'Sí',
      unsaved_changes: 'Algunos cambios no se guardaron. ¿Desea descartarlos?',
    },
    navigation: {
      ...englishMessages.ra?.navigation,
      no_results: 'No se encontraron resultados',
      no_more_results: 'La página %{page} está fuera de los límites. Pruebe la página anterior.',
      page_out_of_boundaries: 'La página %{page} está fuera de los límites',
      page_out_from_end: 'No se puede ir después de la última página',
      page_out_from_begin: 'No se puede ir antes de la página 1',
      page_range_info: '%{offsetBegin}-%{offsetEnd} de %{total}',
      partial_page_range_info: '%{offsetBegin}-%{offsetEnd} de más de %{offsetEnd}',
      current_page: 'Página %{page}',
      page: 'Ir a la página %{page}',
      first: 'Ir a la primera página',
      last: 'Ir a la última página',
      next: 'Siguiente',
      previous: 'Anterior',
      page_rows_per_page: 'Filas por página:',
      skip_nav: 'Ir al contenido',
    },
    sort: {
      sort_by: 'Ordenar por %{field} %{order}',
      ASC: 'ascendente',
      DESC: 'descendente',
    },
    auth: {
      ...englishMessages.ra?.auth,
      auth_check_error: 'Por favor, inicie sesión para continuar',
      user_menu: 'Perfil',
      username: 'Usuario',
      password: 'Contraseña',
      email: 'Correo electrónico',
      sign_in: 'Iniciar sesión',
      sign_in_error: 'Error de autenticación, por favor intente de nuevo',
      logout: 'Cerrar sesión',
    },
    notification: {
      ...englishMessages.ra?.notification,
      updated: 'Elemento actualizado |||| %{smart_count} elementos actualizados',
      created: 'Elemento creado',
      deleted: 'Elemento eliminado |||| %{smart_count} elementos eliminados',
      bad_item: 'Elemento incorrecto',
      item_doesnt_exist: 'El elemento no existe',
      http_error: 'Error de comunicación con el servidor',
      data_provider_error: 'Error del proveedor de datos. Revise la consola.',
      canceled: 'Acción cancelada',
      logged_out: 'Su sesión ha finalizado, por favor reconéctese.',
      not_authorized: 'No está autorizado para acceder a este recurso.',
      application_update_available: 'Hay una nueva versión disponible.',
    },
    validation: {
      ...englishMessages.ra?.validation,
      required: 'Requerido',
      minLength: 'Debe tener al menos %{min} caracteres',
      maxLength: 'Debe tener %{max} caracteres o menos',
      minValue: 'Debe ser al menos %{min}',
      maxValue: 'Debe ser %{max} o menos',
      number: 'Debe ser un número',
      email: 'Debe ser un correo electrónico válido',
      oneOf: 'Debe ser uno de: %{options}',
      regex: 'Debe coincidir con un formato específico (regexp): %{pattern}',
    },
    saved_queries: {
      ...englishMessages.ra?.saved_queries,
      label: 'Consultas guardadas',
      query_name: 'Nombre de consulta',
      new_label: 'Guardar consulta actual...',
      new_dialog_title: 'Guardar consulta actual como',
      remove_label: 'Eliminar consulta guardada',
      remove_label_with_name: 'Eliminar consulta "%{name}"',
      remove_dialog_title: 'Eliminar consulta guardada',
      remove_message: '¿Está seguro de eliminar esta consulta guardada?',
      help: 'Filtre la lista y guarde esta consulta para más tarde',
    },
  },
  pos: {
    app_title: 'Portal Veterinario',
    login: {
      title: 'Iniciar sesión en adapet.ai',
      forgot_password: '¿Olvidó su contraseña?',
      no_account: '¿No tiene una cuenta?',
      sign_up: 'Registrarse',
      or: 'o',
      continue_microsoft: 'Continuar con Microsoft',
    },
    shared_with_me: {
      load_failed: 'Error al cargar los datos compartidos. Por favor intente más tarde.',
      empty_title: 'No hay mascotas compartidas con usted',
      empty_subtitle:
        'Cuando otros veterinarios compartan sus mascotas con usted, aparecerán aquí.',
      shared_by: 'Compartido por %{name}',
      all_pets: 'Todas las mascotas',
      specific_pets: '%{count} mascota específica |||| %{count} mascotas específicas',
      you_can: 'Puede: %{permissions}',
      shared_at: 'Compartido: %{date}',
      expires_at: 'Expira: %{date}',
      shared_pets_label: 'Mascotas compartidas:',
      view_pet: 'Ver mascota',
      pet_meta: '%{species} • Dueño: %{owner}',
      all_pets_message: 'Tiene acceso a todas las mascotas de los clientes de %{name}.',
      permissions: {
        view_metrics: 'Ver métricas',
        view_emrs: 'Ver historiales',
        add_activities: 'Agregar actividades',
        add_emr_notes: 'Agregar notas',
      },
    },
    consent: {
      loading: 'Cargando solicitudes de consentimiento...',
      title: 'Solicitudes de membresía del grupo',
      title_with_count: 'Solicitudes de membresía del grupo (%{count})',
      no_pending: 'No tiene solicitudes pendientes de membresía.',
      pending_warning: 'Tiene solicitudes pendientes de membresía que requieren su consentimiento.',
      pending_chip: 'Pendiente',
      accept: 'Aceptar',
      decline: 'Rechazar',
      cancel: 'Cancelar',
      invited_by: 'Invitado por: %{name} (%{email})',
      invited_on: 'Invitado el: %{date}',
      accept_dialog_title: 'Aceptar membresía del grupo',
      decline_dialog_title: 'Rechazar membresía del grupo',
      accept_question: '¿Desea unirse al grupo "%{group}"?',
      decline_question: '¿Está seguro de rechazar la invitación a "%{group}"?',
      accept_warning:
        'Al aceptar, compartirá los datos de su mascota con los otros miembros del grupo.',
      notes_label: 'Notas (opcional)',
      accept_notes_placeholder: 'Agregue notas sobre unirse a este grupo...',
      decline_notes_placeholder: 'Agregue una razón para rechazar (opcional)...',
      load_failed: 'Error al cargar las solicitudes',
      update_failed: 'Error al actualizar el consentimiento',
    },
    auth: {
      login: {
        email_not_verified:
          'Por favor verifica tu correo electrónico antes de iniciar sesión. Revisa tu bandeja de entrada para encontrar el enlace de verificación.',
        invalid_credentials: 'Correo electrónico o contraseña incorrectos.',
        account_locked:
          'Tu cuenta está bloqueada temporalmente debido a demasiados intentos fallidos. Inténtalo de nuevo más tarde.',
        role_not_allowed:
          'Esta cuenta no tiene acceso al portal veterinario. Los dueños de mascotas deben usar la aplicación móvil Adapet Medical.',
        generic_error: 'Error al iniciar sesión. Inténtalo de nuevo.',
        oauth_failed:
          'Error al iniciar sesión con ese proveedor. Inténtalo de nuevo o usa correo y contraseña.',
      },
      forgot_password: {
        title: 'Olvidé mi contraseña',
        description:
          'Ingrese su correo electrónico y le enviaremos un enlace para restablecer su contraseña.',
        email_label: 'Correo electrónico',
        sending: 'Enviando...',
        send_button: 'Enviar correo de restablecimiento',
        back_to_login: 'Volver al inicio de sesión',
        success: '¡Correo de restablecimiento enviado! Por favor revise su bandeja de entrada.',
        email_required: 'El correo electrónico es obligatorio',
        send_failed: 'Error al enviar el correo de restablecimiento',
        connection_error: 'No se puede conectar al servidor. Por favor intente más tarde.',
      },
      reset_password: {
        title: 'Restablecer contraseña',
        invalid_link_title: 'Enlace de restablecimiento inválido',
        invalid_link_message:
          'Este enlace de restablecimiento de contraseña no es válido o ha caducado.',
        request_new: 'Solicitar nuevo enlace',
        new_password_label: 'Nueva contraseña',
        confirm_password_label: 'Confirmar nueva contraseña',
        resetting: 'Restableciendo...',
        reset_button: 'Restablecer contraseña',
        success: '¡Contraseña restablecida! Redirigiendo al inicio de sesión...',
        invalid_request:
          'Solicitud inválida. Por favor solicite un nuevo enlace de restablecimiento.',
        reset_failed: 'Error al restablecer la contraseña. El enlace puede haber caducado.',
        network_error: 'Error de red. Por favor intente de nuevo.',
        password_required: 'La contraseña es obligatoria',
        passwords_dont_match: 'Las contraseñas no coinciden',
      },
    },
    search: 'Buscar',
    configuration: 'Configuración',
    language: 'Idioma',
    action: {
      change_theme: 'Cambiar tema',
    },
    theme: {
      name: 'Tema',
      light: 'Claro',
      dark: 'Oscuro',
    },
    dashboard: {
      title: 'Panel',
      welcome_subtitle: 'Bienvenido de nuevo a Adapet Medical. Esto es lo que sucede hoy.',
      active_patient_context: 'Contexto de paciente activo:',
      pet_id_label: 'ID de mascota: %{id}',
      no_patient_selected: 'Ningún paciente seleccionado (Vista del sistema)',
      pets_section: 'Mascotas',
      devices_section: 'Dispositivos',
      monthly_revenue: 'Ingresos mensuales',
      month_history: 'Historial de ingresos de 30 días',
      new_orders: 'Nuevos pedidos',
      pending_emrs: 'Historiales pendientes',
      all_emrs: 'Ver todos los historiales',
      new_customers: 'Nuevos clientes',
      all_customers: 'Ver todos los clientes',
      pending_orders: 'Pedidos pendientes',
      current_selected_pet: 'Mascota seleccionada actualmente:',
      recently_updated: 'Actualizados recientemente',
      generate_report: 'Generar reporte',
      glucose_report: 'Reporte de glucosa',
      glucose_trend: 'Tendencia de glucosa',
      daily_tir: 'TIR diario',
      daily_trends_and_activities: 'Tendencias diarias de glucosa y actividades',
      simple_view: 'Vista simple',
      full_report: 'Reporte completo',
      print_report: 'Imprimir reporte',
      no_data: 'N/A',
      activity_logs: 'Registro de actividades',
      log_event_prompt:
        'Haga clic en + Registrar evento para rastrear actividades de insulina, alimentación o ejercicio',
      date_range_navigation: 'Navegación por rango de fechas',
      clinical_notes: 'Notas clínicas',
      add_note_description: 'Agregue una nota para esta mascota que se incluirá en el reporte PDF.',
      portal_view: 'Vista del portal',
      no_device_selected: 'No hay dispositivo disponible para esta mascota',
      no_devices: 'No se encontraron dispositivos para esta mascota',
      search_pets: 'Buscar por propietario, nombre de mascota, ID...',
      error_loading_data: 'Error al cargar datos',
      no_data_available: 'No hay datos disponibles',
      order: {
        items: 'por %{customer_name}, un artículo |||| por %{customer_name}, %{nb_items} artículos',
      },
      welcome: {
        title: 'Bienvenido al Sistema de Monitoreo de Glucosa Veterinario',
        subtitle:
          'Este es un sistema de gestión de monitoreo de glucosa para mascotas. Puede explorar y modificar los datos libremente.',
        ra_button: 'Sitio de react-admin',
        demo_button: 'Código fuente de esta demostración',
      },
    },
    help: {
      menu_title: 'Ayuda y soporte',
      page_title: 'Centro de ayuda VetPo',
      title: 'Ayuda y soporte',
      welcome_message:
        'Bienvenido al Centro de ayuda de VetPo. Encuentre guías, tutoriales y recursos de soporte para aprovechar al máximo su sistema de monitoreo de glucosa.',
      current_language: 'Idioma actual',
      user_guides: 'Guías de usuario',
      user_guides_desc: 'Guías completas para ayudarle a navegar y usar VetPo de manera efectiva.',
      quick_start: 'Guía de inicio rápido',
      quick_start_desc: 'Comience con los conceptos básicos y la navegación del sistema VetPo.',
      features_guide: 'Guía de funcionalidades',
      features_guide_desc:
        'Descripción completa de todas las funcionalidades y capacidades de VetPo.',
      reading_tables: 'Lectura de tablas',
      reading_tables_desc: 'Aprenda a interpretar las tablas de datos e indicadores de calidad.',
      understanding_charts: 'Comprensión de gráficos',
      understanding_charts_desc:
        'Domine los gráficos de tendencias de glucosa y las visualizaciones analíticas.',
      faq: 'Preguntas frecuentes',
      faq_desc: 'Preguntas comunes y soluciones de resolución de problemas.',
      open_guide: 'Abrir guía',
      quick_reference: 'Referencia rápida',
      quick_ref: {
        navigation: 'Navegación básica',
        navigation_desc: 'Use el menú lateral para acceder a las diferentes secciones',
        pet_selection: 'Selección de mascota',
        pet_selection_desc:
          'Haga clic en las mascotas en el panel principal para comenzar el monitoreo',
        glucose_monitoring: 'Monitoreo de glucosa',
        glucose_monitoring_desc: 'Vea datos en tiempo real y tendencias en los gráficos',
      },
      support_contact: 'Soporte y contacto',
      support_desc: 'Obtenga ayuda cuando más la necesite.',
      support: {
        email: 'Soporte por correo electrónico',
        email_desc: 'support@adapetmedical.com - Respuesta en 24 horas',
        chat: 'Chat en vivo',
        chat_desc: 'Disponible en horario comercial',
        phone: 'Soporte telefónico',
        phone_desc: '1-888-444-2618 - Soporte de emergencia para problemas críticos',
        chat_available:
          'El chat en vivo está disponible. Busque el ícono de chat en la esquina inferior derecha de su pantalla.',
      },
      contact: 'Contacto',
      emergency_notice_title: 'Aviso de emergencia',
      emergency_notice_desc:
        'Para emergencias veterinarias inmediatas, siempre priorice la evaluación clínica directa sobre los datos del sistema. VetPo proporciona herramientas de monitoreo, pero no reemplaza el juicio veterinario profesional.',
    },
    users: {
      promote_success: '%{email} promovido a Administrador de grupo',
      promote_confirm: '¿Promover a %{email} a Administrador de grupo (vetadmin)?',
      promote_failed: 'Error al promover usuario',
      manage_users: 'Administrar usuarios',
      promote_button: 'Promover a Administrador de grupo',
      role_vet: 'Veterinario',
      role_vetadmin: 'Administrador de grupo',
      role_admin: 'Administrador del sistema',
      role_siteadmin: 'Administrador del sitio',
      role_cms: 'Administrador de contenido',
      role_user: 'Propietario de mascota',
      current_language: 'Idioma actual',
      user_guides: 'Guías de usuario',
      user_guides_desc: 'Guías completas para ayudarle a navegar y usar VetPo de manera efectiva.',
      quick_start: 'Guía de inicio rápido',
      quick_start_desc: 'Comience con los conceptos básicos y la navegación del sistema VetPo.',
      features_guide: 'Guía de funcionalidades',
      features_guide_desc:
        'Descripción completa de todas las funcionalidades y capacidades de VetPo.',
      reading_tables: 'Lectura de tablas',
      reading_tables_desc: 'Aprenda a interpretar las tablas de datos e indicadores de calidad.',
      understanding_charts: 'Comprensión de gráficos',
      understanding_charts_desc:
        'Domine los gráficos de tendencias de glucosa y las visualizaciones analíticas.',
      faq: 'Preguntas frecuentes',
      faq_desc: 'Preguntas comunes y soluciones de resolución de problemas.',
      open_guide: 'Abrir guía',
      quick_reference: 'Referencia rápida',
      quick_ref: {
        navigation: 'Navegación básica',
        navigation_desc: 'Use el menú lateral para acceder a las diferentes secciones',
        pet_selection: 'Selección de mascota',
        pet_selection_desc:
          'Haga clic en las mascotas en el panel principal para comenzar el monitoreo',
        glucose_monitoring: 'Monitoreo de glucosa',
        glucose_monitoring_desc: 'Vea datos en tiempo real y tendencias en los gráficos',
      },
      support_contact: 'Soporte y contacto',
      support_desc: 'Obtenga ayuda cuando más la necesite.',
      support: {
        email: 'Soporte por correo electrónico',
        email_desc: 'support@adapetmedical.com - Respuesta en 24 horas',
        chat: 'Chat en vivo',
        chat_desc: 'Disponible en horario comercial',
        phone: 'Soporte telefónico',
        phone_desc: '1-888-444-2618 - Soporte de emergencia para problemas críticos',
        chat_available:
          'El chat en vivo está disponible. Busque el ícono de chat en la esquina inferior derecha de su pantalla.',
      },
      contact: 'Contacto',
      emergency_notice_title: 'Aviso de emergencia',
      emergency_notice_desc:
        'Para emergencias veterinarias inmediatas, siempre priorice la evaluación clínica directa sobre los datos del sistema. VetPo proporciona herramientas de monitoreo, pero no reemplaza el juicio veterinario profesional.',
    },
    chat: {
      title: 'Soporte en vivo',
      welcome_message:
        '¡Hola! ¿En qué puedo ayudarle hoy? Puedo asistirle con preguntas sobre las funcionalidades de VetPo, monitoreo de glucosa o problemas técnicos.',
      input_placeholder: 'Escriba su mensaje...',
      send: 'Enviar',
      typing: 'El soporte está escribiendo',
      status_online: 'En línea',
      status_offline: 'Desconectado',
      powered_by: 'Desarrollado por Soporte VetPo',
      error_general: 'Lo sentimos, ocurrió un error. Por favor, intente de nuevo.',
      error_network: 'Error de red. Por favor, verifique su conexión e intente de nuevo.',
      minimize: 'Minimizar',
      close: 'Cerrar chat',
      unread_indicator: 'Nuevo mensaje',
    },
    client_profile: {
      edit_client: 'Editar cliente',
      dialog_title: 'Editar datos del cliente',
      save: 'Guardar',
      saved: 'Datos del cliente actualizados.',
      save_error: 'No se pudo actualizar el cliente. Inténtelo de nuevo.',
      not_allowed: 'No tiene permiso para editar este cliente.',
      name_too_short: 'El nombre del cliente debe tener al menos 2 caracteres.',
      read_only_hint: 'Solo la clínica vinculada a este cliente puede editar sus datos.',
    },
    pet_edit: {
      pet_information: 'Información de la mascota',
      basic_details_readonly: 'Información básica de la mascota (solo lectura)',
      basic_details_editable: 'Información básica de la mascota (editable por veterinario)',
      owner_name: 'Nombre del propietario',
      editable_fields: 'Campos editables',
      vet_modifiable_fields: 'Campos modificables por el veterinario',
      auto_save: {
        saving: 'Guardando...',
        saved: 'Información de la mascota guardada',
        error: 'Error al guardar información de la mascota',
        unsaved_changes: 'Cambios sin guardar',
        last_saved: 'Último guardado a las %{time}',
      },
    },
    alert_rules: {
      title: 'Reglas de alerta de glucosa',
      glucose_range: 'Rango de glucosa',
      pending_sync: 'Sincronización pendiente',
      unsaved_changes: 'Cambios sin guardar',
      configuration_desc:
        'Configure los umbrales de monitoreo de glucosa y las condiciones de alerta para esta mascota',
      configuration_info:
        'Establezca umbrales de glucosa personalizados para esta mascota. El rango de glucosa de la mascota se calculará automáticamente a partir de los umbrales de hipoglucemia (en mmol/L). Las reglas activarán alertas cuando las lecturas de glucosa excedan estos umbrales.',
      add_rule_tooltip: 'Agregar nueva regla de alerta',
      save_rules: 'Guardar reglas',
      saving: 'Guardando...',
      loading: 'Cargando reglas de alerta...',
      no_rules_configured:
        'No hay reglas de alerta configuradas. Haga clic en "Agregar regla" para crear reglas de monitoreo de glucosa para esta mascota.',
      rule_types: {
        critical_hypoglycemia: 'Hipoglucemia crítica',
        warning_hypoglycemia: 'Hipoglucemia de advertencia',
        critical_hyperglycemia: 'Hiperglucemia crítica',
        warning_hyperglycemia: 'Hiperglucemia de advertencia',
        rapid_drop: 'Descenso rápido',
        dawn_pattern: 'Patrón del amanecer',
        somogyi_pattern: 'Patrón Somogyi',
        postprandial_spikes: 'Picos postprandiales',
      },
      thresholds: {
        critical_threshold: 'Umbral crítico',
        warning_threshold: 'Umbral de advertencia',
        hyperglycemia_threshold: 'Umbral de hiperglucemia',
        severe_hyperglycemia_threshold: 'Umbral de hiperglucemia severa',
        somogyi_rebound_threshold: 'Umbral de rebote Somogyi',
        dawn_elevation_threshold: 'Umbral de elevación del amanecer',
        drop_threshold: 'Umbral de descenso',
        analysis_window: 'Ventana de análisis (horas)',
        postprandial_spike_threshold: 'Umbral de pico postprandial',
        severe_spike_threshold: 'Umbral de pico severo',
        postprandial_window_hours: 'Ventana post-comida (horas)',
        pre_meal_window_hours: 'Ventana pre-comida (horas)',
      },
      fields: {
        rule_type: 'Tipo de regla',
        unit: 'Unidad',
        trigger_count: 'Conteo de activaciones',
        trigger_count_helper: 'Conteo de uso (solo lectura)',
        notes: 'Notas',
        notes_placeholder: 'Descripción breve o notas sobre esta regla',
        active: 'Activa',
        active_status: 'Activa',
        inactive_status: 'Inactiva',
        email_notifications: 'Notificaciones por correo',
        sms_notifications: 'Notificaciones por SMS',
      },
      notification_settings: 'Configuración de notificaciones',
      delete_rule_tooltip: 'Eliminar esta regla',
      add_rule: 'Agregar regla',
      save: 'Guardar',
      auto_saving: 'Guardado automático...',
      all_rule_types_added: 'Todos los tipos de regla agregados',
      help_text: {
        critical_hypoglycemia:
          'Activa alertas críticas cuando la glucosa cae por debajo de este umbral. Requiere intervención inmediata.',
        warning_hypoglycemia:
          'Activa alertas de advertencia cuando la glucosa cae por debajo de este umbral. Requiere monitoreo.',
        critical_hyperglycemia:
          'Activa alertas críticas cuando la glucosa sube por encima de este umbral. Riesgo de cetoacidosis.',
        warning_hyperglycemia:
          'Activa alertas de advertencia cuando la glucosa sube por encima de este umbral. Requiere monitoreo.',
        rapid_drop:
          'Activa alertas cuando la glucosa desciende a la tasa especificada a lo largo del tiempo. Usa el umbral de descenso rápido para la detección y el umbral de advertencia para el monitoreo de hipoglucemia.',
        dawn_pattern:
          'Detecta patrones de elevación de glucosa matutina. Analiza datos en la ventana de tiempo especificada.',
        somogyi_pattern:
          'Detecta hiperglucemia de rebote después de episodios hipoglucémicos. Requiere ventana de análisis para la detección de patrones.',
        postprandial_spikes:
          'Detecta picos de glucosa después de las comidas comparando la glucosa postprandial con la línea base previa a la comida.',
      },
      somogyi_note:
        'Nota: El umbral de hipoglucemia nocturna se determina automáticamente a partir de sus reglas existentes de Hipoglucemia Crítica o de Advertencia. Configure esas reglas por separado para establecer el umbral nocturno bajo (10 PM - 6 AM).',
      help_ranges: {
        critical_threshold: 'Rango: 1.0-4.0 mmol/L. Peligro de muerte por debajo de 2.8 mmol/L.',
        warning_threshold: 'Rango: 3.0-5.5 mmol/L. Debe estar por encima del umbral crítico.',
        hyperglycemia_threshold: 'Rango: 8.0-25.0 mmol/L. Debe estar por debajo del umbral severo.',
        severe_hyperglycemia_threshold:
          'Rango: 12.0-30.0 mmol/L. Riesgo de cetoacidosis por encima de 16.0.',
        somogyi_rebound_threshold: 'Rango: 6.0-20.0 mmol/L. Nivel de glucosa de rebote matutino.',
        dawn_elevation_threshold: 'Rango: 5.0-15.0 mmol/L. Elevación natural de glucosa matutina.',
        rapid_drop_threshold:
          'Rango: 1.0-5.0 mmol/L por 15 minutos. Tasa de descenso de glucosa que activa alertas de descenso rápido. El algoritmo analiza los últimos 30 minutos de datos.',
        analysis_window: 'Rango: 12-72 horas. Período de tiempo para análisis de patrones.',
        postprandial_spike_threshold:
          'Rango: 3.0-10.0 mmol/L. Umbral personalizado de pico por encima de la línea base.',
        severe_spike_threshold: 'Rango: 5.0-15.0 mmol/L. Umbral más alto para picos severos.',
        postprandial_window_hours:
          'Rango: 2.0-6.0 horas. Ventana de tiempo después de las comidas para monitorear picos.',
        pre_meal_window_hours:
          'Rango: 0.5-3.0 horas. Ventana de tiempo antes de las comidas para cálculo de línea base.',
      },
      metadata: {
        last_triggered: 'Última activación',
        total_triggers: 'Total de activaciones',
      },
      notifications: {
        saved_successfully: 'Reglas de alerta guardadas correctamente',
        saved_locally: 'Reglas de alerta guardadas localmente (servidor no disponible)',
        could_not_load:
          'No se pudieron cargar las reglas de alerta. Usando valores predeterminados.',
        glucose_range_stored:
          'Rango de glucosa calculado y almacenado localmente (el servidor podría no estar disponible)',
        glucose_range_synced: 'Rango de glucosa sincronizado con el servidor',
      },
      validation: {
        required: 'Este campo es obligatorio',
        out_of_range: 'El valor debe estar entre {min} y {max} {unit}',
        critical_threshold: 'El umbral crítico debe estar entre 1.0 y 4.0 mmol/L (18-72 mg/dL)',
        warning_threshold:
          'El umbral de advertencia debe estar entre 3.0 y 5.5 mmol/L (54-99 mg/dL)',
        hyperglycemia_threshold:
          'El umbral de hiperglucemia debe estar entre 8.0 y 25.0 mmol/L (144-450 mg/dL)',
        severe_hyperglycemia_threshold:
          'El umbral de hiperglucemia severa debe estar entre 12.0 y 30.0 mmol/L (216-540 mg/dL)',
        somogyi_rebound_threshold:
          'El umbral de rebote Somogyi debe estar entre 6.0 y 20.0 mmol/L (108-360 mg/dL)',
        dawn_elevation_threshold:
          'El umbral de elevación del amanecer debe estar entre 5.0 y 15.0 mmol/L (90-270 mg/dL)',
        rapid_drop_threshold:
          'El umbral de descenso rápido debe estar entre 1.0 y 5.0 mmol/L (18-90 mg/dL) por 15 minutos',
        postprandial_spike_threshold:
          'El umbral de pico postprandial debe estar entre 3.0 y 10.0 mmol/L (54-180 mg/dL)',
        severe_spike_threshold:
          'El umbral de pico severo debe estar entre 5.0 y 15.0 mmol/L (90-270 mg/dL)',
        postprandial_window_hours: 'La ventana post-comida debe estar entre 2.0 y 6.0 horas',
        pre_meal_window_hours: 'La ventana pre-comida debe estar entre 0.5 y 3.0 horas',
        analysis_window: 'La ventana de análisis debe estar entre 12 y 72 horas',
        cannot_save_with_errors:
          'No se puede guardar: por favor corrija los errores de validación antes de guardar',
      },
    },
    alerts: {
      title: 'Alertas',
      total: 'total',
      no_alerts: 'No hay alertas que coincidan con los filtros actuales',
      alert_context: 'Contexto de la alerta',
      recommendations: 'Recomendaciones',
      details: 'Detalles',
      acknowledge: 'Reconocer',
      acknowledged: 'Reconocida',
      active: 'Activa',
      resolved: 'Resuelta',
      dismissed: 'Descartada',
      unacknowledged_count: '%{count} sin reconocer',
      refresh_tooltip: 'Actualizar alertas',
      monitoring_issue: 'Problema de monitoreo de alertas',
      monitoring_issue_retry:
        'Es posible que las alertas no se muestren correctamente. Haga clic en actualizar para reintentar.',
      no_recent_alerts: 'No hay alertas recientes',
      checking_interval: 'Verificando alertas cada %{minutes} minutos',
      acknowledged_at: 'Reconocida: %{time}',
      acknowledge_success: 'Alerta reconocida correctamente',
      acknowledge_failed: 'Error al reconocer la alerta',
      acknowledge_tooltip: 'Reconocer alerta',
      show_details: 'Mostrar detalles',
      pet_alerts: 'Alertas de la mascota %{petId}',
      all_pets: 'Todas las mascotas',
      showing_count: 'Mostrando %{shown} de %{total} alertas',
      critical_require_attention: '%{count} alerta(s) crítica(s) requiere(n) atención inmediata',
      critical_alerts_count: '%{count} alerta(s) crítica(s)',
      active_alerts_count: '%{count} alertas activas',
      navigate_cannot: 'No se puede navegar: ID de mascota no encontrado para esta alerta',
      filter: {
        severity: 'Severidad',
        type: 'Tipo',
        status: 'Estado',
        all: 'Todas',
        hypoglycemia: 'Hipoglucemia',
        hyperglycemia: 'Hiperglucemia',
        somogyi: 'Somogyi',
        trend: 'Tendencia',
      },
      type: {
        hypoglycemia: 'Glucosa baja',
        critical_hypoglycemia: 'Baja crítica',
        hyperglycemia: 'Glucosa alta',
        rapid_drop: 'Descenso rápido',
        pattern_detected: 'Patrón',
        somogyi: 'Patrón Somogyi',
        sensor_failure: 'Problema del sensor',
        trend: 'Análisis de tendencia',
        trend_analysis: 'Análisis de tendencia',
        system: 'Alerta del sistema',
      },
      severity: {
        critical: 'Crítica',
        high: 'Alta',
        medium: 'Media',
        low: 'Baja',
      },
      messages: {
        critical_attention: 'alerta(s) crítica(s) requiere(n) atención inmediata',
        hypoglycemia_detected:
          'Hipoglucemia detectada - nivel de glucosa por debajo del rango seguro',
        hyperglycemia_detected:
          'Hiperglucemia detectada - nivel de glucosa por encima del rango objetivo',
        somogyi_detected: 'Patrón Somogyi detectado por análisis de IA',
        trend_analysis_available: 'Nuevo análisis de tendencia de glucosa disponible',
      },
      configuration: {
        title: 'Configuración de alertas',
        description: 'Configure los umbrales de alerta de IA y los parámetros de detección',
        hypoglycemia_section: 'Detección de hipoglucemia',
        hyperglycemia_section: 'Detección de hiperglucemia',
        somogyi_section: 'Detección del fenómeno Somogyi',
        trend_analysis_section: 'Análisis de tendencias con IA',
        custom_rules_section: 'Reglas de alerta personalizadas',
        save_config: 'Guardar configuración',
        reset_config: 'Restablecer a valores predeterminados',
        apply_preset: 'Aplicar preajuste',
        presets: {
          conservative: 'Conservador (alta sensibilidad)',
          standard: 'Estándar (equilibrado)',
          aggressive: 'Agresivo (baja sensibilidad)',
        },
      },
      thresholds: {
        critical_threshold: 'Umbral crítico',
        high_threshold: 'Umbral de prioridad alta',
        medium_threshold: 'Umbral de prioridad media',
        confidence_threshold: 'Confianza mínima',
        rebound_magnitude: 'Magnitud mínima de rebote',
      },
      notifications: {
        email_sent: 'Notificación por correo enviada',
        push_sent: 'Notificación push enviada',
        dashboard_updated: 'Notificación del panel creada',
        vet_warning_sent: 'Advertencia al veterinario enviada',
        daily_report_sent: 'Reporte diario enviado',
      },
      reports: {
        daily_report: 'Reporte diario de alertas',
        summary_title: 'Resumen de alertas',
        glucose_summary: 'Resumen de glucosa',
        patterns_detected: 'Patrones detectados',
        ai_recommendations: 'Recomendaciones de IA',
        report_period: 'Período del reporte',
        total_readings: 'Total de lecturas',
        time_in_range: 'Tiempo en rango',
        episodes_count: 'Conteo de episodios',
        generate_report: 'Generar reporte',
        download_report: 'Descargar reporte',
        email_report: 'Enviar reporte por correo',
      },
    },
    menu: {
      section_patients: 'Pacientes',
      section_sharing: 'Colaboración',
      section_admin: 'Administración',
      clinic_teams: 'Equipo de clínica',
      all_teams_readonly: 'Todos los equipos (solo lectura)',
      manage_users: 'Gestionar usuarios',
      my_account: 'Mi cuenta',
      pet_shares_hint:
        'Comparta mascotas específicas (o todas sus mascotas) con otro veterinario, y vea las mascotas compartidas con usted.',
      sales: 'Ventas',
      catalog: 'Catálogo',
      customers: 'Clientes',
    },
    events: {
      review: {
        title: 'Publicó una reseña en "%{product}"',
      },
      order: {
        title: 'Ordenó 1 póster |||| Ordenó %{smart_count} pósteres',
      },
    },
    export: {
      button: 'Exportar',
      pdf: 'Exportar como PDF',
      image: 'Exportar como imagen',
    },
    glucose: {
      no_devices_found: 'No se encontraron dispositivos de monitoreo de glucosa para esta mascota.',
      trend_over_time: 'Tendencia de glucosa a lo largo del tiempo',
      statistics_range: 'Estadísticas de glucosa y análisis de rango',
      time_in_range_analysis: 'Análisis de tiempo en rango',
      no_data_available: 'No hay datos disponibles',
      event_band: 'Línea de tiempo de eventos de actividad',
      view_day: 'Día',
      view_week: 'Semana',
      view_month: 'Mes',
      reset_view: 'Restablecer vista',
      reset_group: 'Restablecer grupo',
      reset_selection: 'Restablecer selección',
      select_date: 'Seleccionar fecha',
      start_date: 'Fecha de inicio',
      end_date: 'Fecha de fin',
      date_range: 'Rango de fechas',
      single_date: 'Fecha única',
      filter_date_range: 'Filtrar rango de fechas',
      available_range: 'Rango disponible',
      configure_target_range: 'Configurar rango objetivo',
      show_activity_markers: 'Mostrar marcadores de actividad',
      hide_activity_markers: 'Ocultar marcadores de actividad',
      target_range_settings: 'Configuración del rango objetivo',
      target_low: 'Objetivo bajo',
      target_high: 'Objetivo alto',
      current_unit: 'Unidad actual',
      out_of_range: 'Fuera de rango',
      target_range_preview: 'Vista previa',
      loading_stats: 'Cargando estadísticas...',
      error_loading_stats: 'Error al cargar estadísticas:',
      glucose_statistics: 'Estadísticas de glucosa',
      image_export_requires:
        'La funcionalidad de exportación de imagen requiere la biblioteca html2canvas',
      days: 'Días',
      time_sensor_active: 'Tiempo de sensor activo:',
      healthy_glucose_range: 'Rango saludable de glucosa:',
      below_range: 'Por debajo del rango',
      above_range: 'Por encima del rango',
      average_glucose: 'Glucosa promedio',
      glucose_variability: 'Variabilidad de glucosa (CV)',
      target_cv_message: 'Objetivo CV ≤36% para un control óptimo de glucosa',
      snapshot: 'Resumen',
      libre_view: 'LibreView',
      average_glucose_caps: 'GLUCOSA PROMEDIO',
      percent_above_target: '% por encima del objetivo',
      percent_in_target: '% en objetivo',
      percent_below_target: '% por debajo del objetivo',
      low_glucose_events: 'EVENTOS DE GLUCOSA BAJA',
      average_duration: 'Duración promedio:',
      carbs: 'Carbohidratos',
      carbohydrate_intake: '🍎 INGESTA DE CARBOHIDRATOS',
      insulin: 'INSULINA',
      rapid_acting_insulin: '💉 INSULINA DE ACCIÓN RÁPIDA',
      long_acting_insulin: '💉 INSULINA DE ACCIÓN PROLONGADA',
      total_daily_insulin: '📊 INSULINA DIARIA TOTAL',
      comments: 'Comentarios',
      min: 'Min',
      no_significant_issues: 'No se detectaron problemas significativos en este período.',
      loading_chart: 'Cargando gráfico...',
      error_loading_chart: 'Error al cargar gráfico',
      time_in_range: 'Tiempo en rango',
      very_high: 'Muy alto (>13.9)',
      high: 'Alto (10.1-13.9)',
      target: 'Objetivo (3.9-10.0)',
      low: 'Bajo (3.0-3.8)',
      very_low: 'Muy bajo (<3.0)',
      unit: 'mmol/L',
      hour_abbr: 'h',
      minute_abbr: 'min',
      gram_abbr: 'g',
      unit_abbr: 'u',
      summary_report: 'Reporte resumido',
      report_period: 'Período del reporte',
      report_generated: 'Reporte generado',
      sensor_coverage: 'Cobertura del sensor',
      standard_deviation: 'Desviación estándar (SD)',
      effective_days: 'Días efectivos',
      data_from_continuous_monitoring: 'Datos de monitoreo continuo con intervalos de 3 minutos',
      range_distribution: 'TIR (Tiempo en rango)',
      ideal_targets: 'Objetivos ideales',
      target_range_goal: 'Tiempo en rango objetivo ≥70%',
      low_glucose_goal: 'Glucosa baja <4%',
      variability_goal: 'Coeficiente de variación <36%',
      zoom_view: 'Vista ampliada',
      zoom_chart: 'Ampliar gráfico',
      close_zoom: 'Cerrar ampliación',
      detailed_view: 'Vista detallada',
      summary_metrics: 'Métricas resumidas',
      show_events: 'Mostrar eventos',
      hide_events: 'Ocultar eventos',
      previous_day: 'Día anterior',
      next_day: 'Día siguiente',
      duration_in_range: 'Duración en rango',
      zoom_tooltip: 'Haga clic para ampliar este día',
      before_device_start: 'Antes de la activación del dispositivo',
      // Dashboard Part 2 - TIR Summary
      tir_statistics: 'Estadísticas TIR',
      target_range: 'Rango objetivo',
      time_below_range: 'Tiempo por debajo del rango (TBR)',
      time_above_range: 'Tiempo por encima del rango (TAR)',
      data_coverage: 'Cobertura de datos',
      readings: 'lecturas',
      unit_mmol: 'mmol/L',
      time: 'Tiempo',
      glucose: 'Glucosa',
      // Dashboard Part 7 - Low Glucose Events
      events: 'eventos',
      showing_events_below: 'Mostrando eventos por debajo de',
      no_low_events: 'No se detectaron eventos de glucosa baja',
      no_low_events_description:
        'No hay lecturas por debajo de %{threshold} %{unit} en este período',
      // Loading/error states
      loading_snapshot: 'Cargando resumen...',
      error_loading_snapshot: 'Error al cargar resumen',
      loading_range_bar: 'Cargando barra de rango...',
      error_loading_range_bar: 'Error al cargar barra de rango',
      loading_daily_tir: 'Cargando gráfico TIR diario...',
      error_loading_daily_tir: 'Error al cargar gráfico TIR diario',
      error_loading_trend: 'Error al cargar gráfico',
      // Chart labels
      glucose_range_distribution: 'Distribución del rango de glucosa',
      time_format_note: 'Formato de hora: HH:MM (basado en intervalos de lectura de 3 minutos)',
      time_in_range_percent: 'Tiempo en rango (%)',
      glucose_overline: 'Glucosa',
      target_range_label: 'Rango objetivo',
      no_data_text: 'Sin datos',
      showing_devices: 'Mostrando datos de %{count} dispositivos',
      estimated: '(Estimado)',
      y_position_estimated: '(Posición Y estimada)',
      view_all: 'Todos',
      // Auto-generated comments
      auto_comment_missing_insulin:
        '%{days} días en este período no tienen eventos de insulina registrados.',
      auto_comment_no_carbs:
        'No hay datos de ingesta de carbohidratos disponibles para este período.',
      auto_comment_high_low_events:
        'Alto número de eventos de glucosa baja (%{count}) detectados. Considere ajustar la insulina.',
      // SummaryReportSection metric card labels
      avg_glucose_short: 'Glucosa prom.',
      cv_short: 'CV',
      std_dev_short: 'Desv. est.',
      coverage_suffix: 'cobertura',
      // GlucoseLineChart
      error_loading_chart_detail: 'Error al cargar gráfico: %{error}',
    },
    // Dashboard Part 3 - AGP
    agp: {
      time_of_day: 'Hora del día',
      title: 'Perfil ambulatorio de glucosa',
      percentile_bands: 'Bandas de percentiles',
      median: 'Mediana (50.o)',
    },
    // Dashboard Part 3 - Vet Notes
    notes: {
      vet_notes: 'Notas veterinarias',
      add_note: 'Agregar nota',
      save_note: 'Guardar nota',
      enter_note: 'Ingrese su nota clínica...',
      no_notes: 'Sin notas aún',
      add_first_note: 'Agregue la primera nota para esta mascota',
      total_notes: '%{count} notas',
      show_more: 'Mostrar más',
      show_less: 'Mostrar menos',
      select_pet_first: 'Seleccione una mascota para ver las notas',
      created_successfully: 'Nota creada correctamente',
      error_creating: 'Error al crear nota',
      include_in_report: 'Incluir en reportes PDF',
      include_in_report_help: 'Desmarcar para notas internas solamente',
      internal_note: 'Interna',
    },
    // Dashboard Part 6 - Activities
    activities: {
      no_activities: 'No hay actividades registradas',
    },
    pdf: {
      generate_report: 'Generar reporte',
      preparing: 'Preparando...',
      capturing: 'Capturando gráficos...',
      generating: 'Generando PDF...',
      complete: '¡Completo!',
      status_description: {
        preparing: 'Preparando datos del reporte',
        capturing: 'Capturando imágenes de gráficos',
        generating: 'Creando documento PDF',
      },
      // Part 8: Date range picker translations
      select_date_range: 'Seleccionar rango de fechas del reporte',
      quick_presets: 'Preajustes rápidos',
      last_7_days: 'Últimos 7 días',
      last_14_days: 'Últimos 14 días',
      last_30_days: 'Últimos 30 días',
      last_90_days: 'Últimos 90 días',
      report_period: 'Período del reporte',
      days: 'días',
      pet_aggregated_notice:
        'El reporte incluirá datos de todos los dispositivos asociados a esta mascota.',
      no_data_warning: 'No hay datos de glucosa disponibles para el rango de fechas seleccionado.',
      actual_data_range: 'Datos disponibles',
      use_actual_range: 'Usar rango de datos',
      checking_data: 'Comprobando los datos disponibles…',
    },
    // Veterinary CGM Report translations (6-page format)
    vet_report: {
      title: 'Reporte veterinario Adapet CGM',
      report_overview: 'Resumen del reporte',
      glucose_control_summary: 'Resumen del control de glucosa',
      key_findings: 'Hallazgos principales',
      tir_statistics: 'Estadísticas TIR',
      time_in_ranges: 'Tiempo en rangos',
      target_range: 'Rango objetivo',
      time_in_range_tir: 'Tiempo en rango (TIR)',
      time_below_range_tbr: 'Tiempo por debajo del rango (TBR)',
      time_above_range_tar: 'Tiempo por encima del rango (TAR)',
      average_glucose: 'Glucosa promedio',
      data_coverage: 'Cobertura de datos',
      range: 'Rango',
      percent: '%',
      time: 'Tiempo',
      // Page 2: AGP
      agp: 'AGP',
      ambulatory_glucose_profile: 'Perfil ambulatorio de glucosa (AGP)',
      pattern_summary: 'Resumen de patrones',
      time_block: 'Bloque de tiempo',
      median: 'Mediana',
      iqr: 'IQR (25-75)',
      comment: 'Comentario',
      // Page 3: Glucose Trend
      glucose_trend: 'Tendencia de glucosa',
      glucose_trend_window: 'Tendencia de glucosa (ventana del reporte)',
      target_range_band_note:
        'El rango objetivo se muestra como banda sombreada. Ejes fijos (Y: 0-30) para una interpretación consistente.',
      notable_segments: 'Segmentos notables y anotaciones',
      date_time: 'Fecha/Hora',
      type: 'Tipo',
      value: 'Valor',
      notes_column: 'Notas',
      no_notable_segments: 'No se detectaron segmentos notables en este período.',
      // Page 4: Daily Overview
      daily_overview: 'Resumen diario',
      daily_time_in_ranges: 'Tiempo diario en rangos',
      daily_metrics: 'Métricas diarias',
      date: 'Fecha',
      avg: 'Prom.',
      min_max: 'Mín-Máx',
      tir: 'TIR',
      tar: 'TAR',
      tbr: 'TBR',
      readings: 'Lecturas',
      activities_column: 'Actividades',
      // Page 5: Daily Trends
      daily_trends: 'Tendencias diarias',
      no_daily_data: 'No hay datos diarios disponibles para el período seleccionado.',
      no_activities_recorded: 'No hay actividades registradas',
      // Page 6: Events & Notes
      events_and_notes: 'Eventos y notas',
      low_glucose_events: 'Eventos de glucosa baja (por debajo del umbral)',
      events_disclaimer:
        'Los eventos son lecturas del sensor marcadas por debajo del umbral configurado. Interprete con correlación clínica.',
      glucose_mmol: 'Glucosa (mmol/L)',
      severity: 'Severidad',
      no_low_events: 'No se detectaron eventos de glucosa baja durante este período.',
      veterinary_assessment: 'Evaluación y plan veterinario',
      clinician: 'Clínico',
      // Footer
      footer_disclaimer:
        'Generado para revisión veterinaria. Interprete en contexto clínico; verifique con pruebas confirmatorias cuando sea necesario.',
      page_of: 'Página %{page} de %{total}',
    },
    common: {
      empty_data: '—',
      add_note: 'Agregar nota',
      not_available: 'N/A',
      clear: 'Limpiar',
    },
    owners: {
      title: 'Propietarios de mascotas',
      total_count: 'Total: %{count} propietarios',
      pets_count: 'Mascotas',
      devices_count: 'Dispositivos',
      select_owner: 'Seleccione un propietario para ver sus mascotas y dispositivos',
    },
    leads: {
      title: 'Prospectos Adapet 2026',
      subtitle:
        'Prospectos de eventos combinados importados de VMX, WVC y archivos adjuntos de correo de Fetch Charlotte.',
      total_records: 'Total de prospectos',
      unique_emails: 'Correos únicos',
      sources: 'Fuentes de prospectos',
      filtered_records: 'Resultados filtrados',
      search_placeholder: 'Buscar por prospecto, empresa, correo, rol o fuente',
      all_events: 'Todos los eventos',
      empty_state: 'No hay prospectos que coincidan con los filtros actuales.',
      access_denied:
        'Solo los administradores del sitio pueden ver los prospectos de marketing importados.',
    },
    shares: {
      share_created_successfully: 'Compartido creado correctamente',
      share_revoked_successfully: 'Compartido revocado correctamente',
      share_creation_failed:
        'Algunos compartidos no se pudieron crear. Por favor, intente de nuevo.',
    },
    profile: {
      title: 'Perfil',
      profile_with_info: 'Perfil: %{name} (ID: %{id})',
      my_profile: 'Mi perfil',
      edit_profile: 'Editar perfil',
      name: 'Nombre',
      id: 'ID',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      clinic: 'Clínica',
      field_clinic_name: 'Nombre de la clínica',
      field_address: 'Dirección',
      field_postal_code: 'Código postal',
      field_city: 'Ciudad',
      field_state: 'Estado / Provincia',
      field_country: 'País',
      country_us: 'Estados Unidos',
      country_ca: 'Canadá',
      validation_state_invalid: 'Por favor, seleccione un estado o provincia válido',
      field_short_description: 'Descripción breve',
      field_full_profile: 'Perfil completo',
      placeholder_short_description: 'Descripción breve de los servicios de su clínica',
      placeholder_full_profile:
        'Descripción detallada de su práctica veterinaria, servicios y especialización',
      not_set: 'No establecido',
      qr_code: 'Código QR',
      glucose_unit: 'Unidad de glucosa',
      glucose_unit_mmol: 'mmol/L',
      glucose_unit_mgdl: 'mg/dL',
      validation_name_required: 'El nombre es obligatorio',
      validation_phone_invalid: 'Por favor, ingrese un número de teléfono válido (10-15 dígitos)',
      validation_postal_invalid: 'Por favor, ingrese un código postal válido',
      profile_updated: 'Perfil actualizado correctamente',
      profile_update_failed: 'Error al actualizar el perfil',
      glucose_unit_saved: 'Preferencia de unidad de glucosa guardada',
      glucose_unit_save_failed: 'Error al guardar la preferencia de unidad de glucosa',
      cancel: 'Cancelar',
      save: 'Guardar',
      saving: 'Guardando...',
      print: 'Imprimir',
      ok: 'OK',
    },
    reports: {
      export_csv: 'Exportar CSV',
      daily_glucose_range: 'Rango diario de glucosa',
      daily_glucose_lines: 'Líneas diarias de glucosa',
      daily_glucose_histograms: 'Histogramas diarios de glucosa',
      combined_glucose_histogram: 'Histograma combinado de glucosa',
      axis_labels: {
        glucose: 'Glucosa',
        date: 'Fecha',
        time_of_day: 'Hora del día',
        count: 'Conteo',
      },
      chart_series: {
        daily_glucose: 'Glucosa diaria',
        daily_avg: 'Promedio diario',
      },
      hover_labels: {
        min: 'Mín',
        max: 'Máx',
        avg: 'Prom',
      },
    },
    metrics: {
      filters: {
        device: 'Dispositivo',
        timestamp_gte: 'Marca de tiempo ≥',
        timestamp_lte: 'Marca de tiempo ≤',
        glucose_gte: 'Glucosa ≥',
        glucose_lte: 'Glucosa ≤',
      },
    },
  },
  resources: {
    customers: {
      name: 'Cliente |||| Clientes',
      fields: {
        orders: 'Pedidos',
        first_seen: 'Visto por primera vez',
        full_name: 'Nombre',
        groups: 'Segmentos',
        last_seen: 'Visto por última vez',
        last_seen_gte: 'Visitado desde',
        name: 'Nombre',
        total_spent: 'Total gastado',
        password: 'Contraseña',
        confirm_password: 'Confirmar contraseña',
        stateAbbr: 'Estado',
      },
      filters: {
        last_visited: 'Última visita',
        today: 'Hoy',
        this_week: 'Esta semana',
        last_week: 'La semana pasada',
        this_month: 'Este mes',
        last_month: 'El mes pasado',
        earlier: 'Anterior',
        has_ordered: 'Ha realizado pedidos',
        has_newsletter: 'Tiene boletín',
        group: 'Segmento',
      },
      fieldGroups: {
        identity: 'Identidad',
        address: 'Dirección',
        stats: 'Estadísticas',
        history: 'Historial',
        password: 'Contraseña',
        change_password: 'Cambiar contraseña',
      },
      page: {
        delete: 'Eliminar cliente',
      },
      errors: {
        password_mismatch: 'La confirmación de contraseña no coincide con la contraseña.',
      },
      notifications: {
        created: 'Cliente creado |||| %{smart_count} clientes creados',
        updated: 'Cliente actualizado |||| %{smart_count} clientes actualizados',
        deleted: 'Cliente eliminado |||| %{smart_count} clientes eliminados',
      },
    },
    groups: {
      name: 'Grupo |||| Grupos',
      fields: {
        name_helper: 'Elija un nombre único para su grupo veterinario',
        description_helper: 'Describa el propósito de este grupo (opcional)',
      },
      notifications: {
        created: 'Grupo creado correctamente',
        updated: 'Grupo actualizado correctamente',
      },
      errors: {
        forbidden: 'No tiene permiso para realizar esta acción',
        create_failed: 'Error al crear grupo. Por favor, intente de nuevo.',
        no_create_permission:
          'No tiene permiso para crear grupos. Solo los administradores veterinarios pueden crear grupos.',
      },
    },
    orders: {
      name: 'Pedido |||| Pedidos',
      amount: '1 pedido |||| %{smart_count} pedidos',
      title: 'Pedido %{reference}',
      fields: {
        basket: {
          delivery: 'Envío',
          reference: 'Referencia',
          quantity: 'Cantidad',
          sum: 'Suma',
          tax_rate: 'Tasa de impuesto',
          taxes: 'Impuesto',
          total: 'Total',
          unit_price: 'Precio unitario',
        },
        address: 'Dirección',
        customer_id: 'Cliente',
        date_gte: 'Posterior a',
        date_lte: 'Anterior a',
        nb_items: 'N.o de artículos',
        total_gte: 'Monto mínimo',
        status: 'Estado',
        returned: 'Devuelto',
      },
      section: {
        order: 'Pedido',
        customer: 'Cliente',
        shipping_address: 'Dirección de envío',
        items: 'Artículos',
        total: 'Totales',
      },
      notifications: {
        created: 'Pedido creado |||| %{smart_count} pedidos creados',
        updated: 'Pedido actualizado |||| %{smart_count} pedidos actualizados',
        deleted: 'Pedido eliminado |||| %{smart_count} pedidos eliminados',
      },
    },
    invoices: {
      name: 'Factura |||| Facturas',
      fields: {
        date: 'Fecha de factura',
        customer_id: 'Cliente',
        order_id: 'Pedido',
        date_gte: 'Posterior a',
        date_lte: 'Anterior a',
        total_gte: 'Monto mínimo',
        address: 'Dirección',
      },
      notifications: {
        created: 'Factura creada |||| %{smart_count} facturas creadas',
        updated: 'Factura actualizada |||| %{smart_count} facturas actualizadas',
        deleted: 'Factura eliminada |||| %{smart_count} facturas eliminadas',
      },
    },
    products: {
      name: 'Póster |||| Pósteres',
      fields: {
        category_id: 'Categoría',
        height_gte: 'Altura mínima',
        height_lte: 'Altura máxima',
        height: 'Altura',
        image: 'Imagen',
        price: 'Precio',
        reference: 'Referencia',
        sales: 'Ventas',
        stock_lte: 'Stock bajo',
        stock: 'Stock',
        thumbnail: 'Miniatura',
        width_gte: 'Ancho mínimo',
        width_lte: 'Ancho máximo',
        width: 'Ancho',
      },
      tabs: {
        image: 'Imagen',
        details: 'Detalles',
        description: 'Descripción',
        emrs: 'Historiales',
      },
      filters: {
        categories: 'Categorías',
        stock: 'Stock',
        no_stock: 'Agotado',
        low_stock: '1 - 9 artículos',
        average_stock: '10 - 49 artículos',
        enough_stock: '50 artículos y más',
        sales: 'Ventas',
        best_sellers: 'Más vendidos',
        average_sellers: 'Promedio',
        low_sellers: 'Bajo',
        never_sold: 'Nunca vendido',
      },
      notifications: {
        created: 'Póster creado |||| %{smart_count} pósteres creados',
        updated: 'Póster actualizado |||| %{smart_count} pósteres actualizados',
        deleted: 'Póster eliminado |||| %{smart_count} pósteres eliminados',
      },
    },
    categories: {
      name: 'Categoría |||| Categorías',
      fields: {
        products: 'Productos',
      },
      notifications: {
        created: 'Categoría creada |||| %{smart_count} categorías creadas',
        updated: 'Categoría actualizada |||| %{smart_count} categorías actualizadas',
        deleted: 'Categoría eliminada |||| %{smart_count} categorías eliminadas',
      },
    },
    owners: {
      name: 'Propietario |||| Propietarios',
      amount: '1 propietario |||| %{smart_count} propietarios',
    },
    leads: {
      name: 'Prospecto |||| Prospectos',
      amount: '1 prospecto |||| %{smart_count} prospectos',
      fields: {
        event: 'Evento',
        name: 'Prospecto',
        email: 'Correo electrónico',
        company: 'Empresa',
        role: 'Rol',
        location: 'Ubicación',
        context: 'Contexto',
        captured_at: 'Fecha de captura',
      },
    },
    pets: {
      name: 'Mascota |||| Mascotas',
      amount: '1 mascota |||| %{smart_count} mascotas',
      detail: 'Detalle de mascota',
      search_placeholder: 'Buscar por nombre de mascota / propietario / raza / especie / ID',
      fields: {
        id: 'ID',
        name: 'Nombre de la mascota',
        owner: 'Propietario',
        pet_name: 'Nombre de la mascota',
        dob: 'Fecha de nac.',
        birthday: 'Fecha de nacimiento',
        created: 'Creado',
        owner_email: 'Correo del propietario',
        owner_website: 'Sitio web del propietario',
        species: 'Especie',
        breed: 'Raza',
        height: 'Altura',
        weight: 'Peso',
        sex: 'Sexo',
        color: 'Color',
        createdAt: 'Creado',
        updatedAt: 'Actualizado',
        sensor_activated: 'Sensor activado',
        vet_account: 'Cuenta veterinaria',
        vet_account_not_bound: 'No vinculada a cuenta veterinaria',
      },
      sex_options: {
        male: 'Macho',
        female: 'Hembra',
        neutered_male: 'Macho castrado',
        spayed_female: 'Hembra esterilizada',
        unknown: 'Desconocido',
      },
      action: {
        accept: 'Aceptar',
        reject: 'Rechazar',
      },
    },
    activities: {
      name: 'Actividad |||| Actividades',
      amount: '1 actividad |||| %{smart_count} actividades',
      detail: 'Detalle de actividad',
      fields: {
        id: 'ID',
        name: 'Nombre',
        owner: 'Propietario',
        pet: 'Mascota',
        pet_id: 'ID de mascota',
        type: 'Tipo',
        start_time: 'Hora de inicio',
        end_time: 'Hora de fin',
        time: 'Duración',
        duration: 'Duración',
        description: 'Descripción',
        created_at: 'Creado el',
        updated_at: 'Actualizado el',
      },
      insulin: {
        brand: 'Marca',
        custom_brand: 'Marca personalizada',
        dosage: 'Dosis',
        units: 'unidades',
      },
      action: {
        accept: 'Aceptar',
        reject: 'Rechazar',
      },
    },
    devices: {
      name: 'Dispositivo |||| Dispositivos',
      amount: '1 dispositivo |||| %{smart_count} dispositivos',
      detail: 'Detalle de dispositivo',
      fields: {
        id: 'ID',
        name: 'Nombre',
        owner: 'Propietario',
        pet: 'Mascota',
        type: 'Tipo',
        start_time: 'Hora de inicio',
        glucose_trend: 'Tendencia de glucosa',
        timezone: 'Zona horaria',
        createdAt: 'Creado',
        updatedAt: 'Actualizado',
      },
      action: {
        accept: 'Aceptar',
        reject: 'Rechazar',
      },
    },
    metrics: {
      name: 'Lectura |||| Lecturas',
      amount: '1 lectura |||| %{smart_count} lecturas',
      detail: 'Detalle de lectura',
      fields: {
        id: 'ID',
        name: 'Nombre',
        owner: 'Propietario',
        device: 'Dispositivo',
        offset: 'Desplazamiento',
        timestamp: 'Marca de tiempo',
        glucose: 'Glucosa',
        createdAt: 'Creado el',
        updatedAt: 'Actualizado el',
      },
      action: {
        accept: 'Aceptar',
        reject: 'Rechazar',
      },
    },
    emrs: {
      name: 'Nota |||| Notas',
      amount: '1 nota |||| %{smart_count} notas',
      detail: 'Detalle de nota',
      fields: {
        id: 'ID',
        pet: 'Mascota',
        pet_id: 'ID de mascota',
        vet: 'Veterinario',
        notes: 'Notas',
        number: '#',
        author: 'Autor',
        content: 'Contenido',
        timestamp: 'Fecha',
        date: 'Fecha',
        created: 'Creado',
        updated: 'Actualizado',
        createdAt: 'Creado',
        updatedAt: 'Actualizado',
      },
      action: {
        accept: 'Aceptar',
        reject: 'Rechazar',
        add_note: 'Agregar nota',
      },
      notifications: {
        created: 'Nota creada |||| %{smart_count} notas creadas',
        updated: 'Nota actualizada |||| %{smart_count} notas actualizadas',
        deleted: 'Nota eliminada |||| %{smart_count} notas eliminadas',
        approved_success: 'Nota aprobada',
        approved_error: 'Error: Nota no aprobada',
        rejected_success: 'Nota rechazada',
        rejected_error: 'Error: Nota no rechazada',
      },
    },
    glucose: {
      axis_labels: {
        max: 'Máx',
        min: 'Mín',
        glucose: 'Glucosa',
        date: 'Fecha',
        time: 'Hora',
      },
      hover_labels: {
        max: 'Máx',
        min: 'Mín',
      },
    },
    segments: {
      name: 'Segmento |||| Segmentos',
      fields: {
        customers: 'Clientes',
        name: 'Nombre',
      },
      data: {
        compulsive: 'Compulsivo',
        collector: 'Coleccionista',
        ordered_once: 'Pidió una vez',
        regular: 'Regular',
        returns: 'Devoluciones',
        reviewer: 'Reseñador',
      },
    },
  },
}

export default customSpanishMessages
